module.exports = "/assets/0df155fde92fcbee8204099333eca07a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/IF.png
// module id = 1472
// module chunks = 0